/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function HybrikTemplateEditViewController(
    this: JS5Object,
    _: JS5Object,
    $routeParams: JS5Object,
    $location: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    HybrikTemplateEditService: JS5Object,
    MediaConversionTemplateService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    const setEditData = (template: JS5Object) => {
        HybrikTemplateEditService.setOriginalEditData(template);
        this.editData = template;
        this.payloadString = JSON.stringify(template.conversionInfo.jobPayload, null, 4);
        if (this.editorForm) {
            this.editorForm.$setPristine();
        }
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        MediaConversionTemplateService.getMediaConversionTemplate($routeParams.id)
            .then(setEditData)
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const saveNewHybrikTemplate = () => {
        MediaConversionTemplateService.createMediaConversionTemplate(this.editData)
            .then((template: JS5Object) => {
                setEditData(template);
                $location.url(`/system/templates/hybrikTemplates/edit/${template.id}`);
            });
    };

    const updateHybrikTemplate = () => {
        MediaConversionTemplateService.updateMediaConversionTemplate(this.editData)
            .then(setEditData)
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    this.toolbarButtonDefs = [{
        label: 'Save',
        enabled: () => !_.get(this.editorForm, '$pristine') && _.get(this.editorForm, '$valid'),
        onClick: () => {
            this.loadingIndicator.show = true;
            try {
                this.editData.conversionInfo.jobPayload = JSON.parse(this.payloadString);
                if ($routeParams.id === '-1') {
                    saveNewHybrikTemplate();
                } else {
                    updateHybrikTemplate();
                }
            } catch (error) {
                NotificationService.createFailureNotification(error.message, '', true, -1);
                this.errorIndex = parseInt(_.chain(error.message)
                    .words()
                    .last()
                    .value());
                this.loadingIndicator.show = false;
            }
        }
    }, {
        label: 'Revert',
        enabled: () => !_.get(this.editorForm, '$pristine'),
        onClick: () => {
            setEditData(_.cloneDeep(HybrikTemplateEditService.originalEditData));
        }
    }, {
        label: 'Close',
        enabled: () => !_.get(this.editorForm, '$dirty'),
        onClick: () => $location.url(`/system/templates/search`).search({tab: 'HybrikTemplates'})
    }];


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        SidebarService.editService = MediaConversionTemplateService;
        this.isAdmin = PermissionsService.isAdmin();
        this.errorIndex = null;
        this.payloadString = '';
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Hybrik Template',
                        location: '/system/templates/search',
                        params: {tab: 'HybrikTemplates'}
                    });
                }
                getData();
            } else {
                setEditData({
                    name: '',
                    converterType: 'Hybrik',
                    conversionInfo: {
                        converterType: 'Hybrik',
                        jobPayload: {
                            name: '',
                            payload: {},
                            definitions: {}
                        }
                    },
                });
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Hybrik Template',
                    location: '/system/templates/search',
                    params: {tab: 'HybrikTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$postLink = () => {
        $timeout(() => {
            HybrikTemplateEditService.editorForm = this.editorForm;
            BreadcrumbService.editService = HybrikTemplateEditService;
        });
    };

    this.$onDestroy = () => {
        HybrikTemplateEditService.originalEditData = null;
        HybrikTemplateEditService.editorForm = null;
    };
}


angular.module('prism-ui.templates').component('hybrikTemplateEditView', {
    templateUrl: 'system/templates/hybrikTemplate/editor/hybrik-template-edit-template.html',
    controller: HybrikTemplateEditViewController,
    bindings: {
    }
});
